export enum TRANSACTION_STATES {
  pendingAssignment = 1,
  assigned,
  inPickUp,
  inPickUpPoint,
  pickedUp,
  inDelivery,
  inDeliveryPoint,
  inReturnToSender,
}

export enum TRANSACTION_STATUS {
  PENDING_ASSIGNMENT = "PENDING_ASSIGNMENT",
  IN_PICK_UP = "IN_PICK_UP",
  ASSIGNED = "ASSIGNED",
  IN_PICK_UP_POINT = "IN_PICK_UP_POINT",
  IN_DELIVERY = "IN_DELIVERY",
  IN_DELIVERY_POINT = "IN_DELIVERY_POINT",
  DELIVERED = "DELIVERED",
  IN_RETURN_TO_SENDER = "IN_RETURN_TO_SENDER",
  RETURNED_TO_SENDER = "RETURNED_TO_SENDER",
  LOST = "LOST",
  CANCEL = "CANCEL"
}

export class TransactionConstants {
  private static cancelableStates = [
    TRANSACTION_STATES.pendingAssignment,
    TRANSACTION_STATES.assigned,
    TRANSACTION_STATES.inPickUp,
    TRANSACTION_STATES.inPickUpPoint,
  ];

  private static finishableStates = [
    TRANSACTION_STATES.pickedUp,
    TRANSACTION_STATES.inDelivery,
    TRANSACTION_STATES.inDeliveryPoint,
    TRANSACTION_STATES.inReturnToSender,
  ];

  public static isCancelEnabled(stateId: number) {
    return this.cancelableStates.includes(stateId);
  }
  public static isFinishEnabled(stateId: number) {
    return this.finishableStates.includes(stateId);
  }
}
